"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const Button_1 = require("@components/buttons/Button");
const _params_1 = require("@params");
const useIPOC_1 = require("@app/routes/IPOCPage/hooks/useIPOC");
const Apply = ({ selectedTags, t }) => {
    const [waiting, setWaiting] = (0, react_1.useState)(false);
    const handleSave = (0, react_1.useCallback)(() => {
        setWaiting(true);
        const searchParams = (0, useIPOC_1.getIPOCSearchParams)();
        fetch(_params_1.apiHost + "/set_ipoc/" + searchParams, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": js_cookie_1.default.get("csrftoken"),
            },
            body: JSON.stringify({
                exercises: selectedTags.map(({ exercise_id, group_slug }, position) => ({
                    exercise_id,
                    group_slug,
                    position,
                })),
            }),
        })
            .then((response) => response.json())
            .then(() => setWaiting(false));
    }, [selectedTags]);
    return (react_1.default.createElement(Button_1.Button, { variant: "primary", onClick: handleSave, disabled: waiting }, waiting ? t.applying : t.apply));
};
exports.default = Apply;
